// src/utils/downloadBlob.ts

/**
 * Hand a generated file to the browser as a download.
 *
 * The object URL is released on the next turn of the event loop rather than
 * synchronously: some webviews start the download after `click()` returns, and
 * a URL revoked before that point downloads nothing.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
